import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAngularjs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="angularjs" maskId="round-filled-radius-1-stroke-1.5-IconAngularjs"><path d="M21.5 5.5L20 17.5L12 22V14.291H14.6045L15.9004 17.2598H18L12 4.23926V2L21.5 5.5Z" fill="currentColor"/><path d="M13.875 12.5205H12V8.42676L13.875 12.5205Z" fill="currentColor"/><g opacity="0.8"><path d="M12 4.23926L6 17.2598H8.09961L9.40039 14.291H12V22L4 17.5L2.5 5.5L12 2V4.23926Z" fill="currentColor"/><path d="M12 12.5205H10.1299L12 8.42676V12.5205Z" fill="currentColor"/></g></CentralIconBase>;
});

export default IconAngularjs;
